export default __webpack_public_path__ + "static/media/gallery_05.7da3439f.jpg";